import React, { Fragment, useEffect } from "react";
import { dateFilterParams, dateValueGetter, formatOnlyDate } from "../utils";
import {
  fetchActiveReceipt,
  fetchDeactiveReceipt,
  fetchReceiptList,
} from "../actions/receipt";
import { useDispatch, useSelector } from "react-redux";

import AggridTable from "../components/Admin/Reusable/AggridTable";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { statusRenderOrder } from "../utils/cellRenderTable";
import { useTranslation } from "react-i18next";

const OrderList = () => {
  const dispatch = useDispatch();

  const { t } = useTranslation();
  //breadcrumb
  const translateModule = "orders";
  const pageType = "List";
  const breadcrumbItems = [
    { label: t(`breadcrumb.${translateModule}`) },
    {
      label: t(`breadcrumb.${translateModule}${pageType}`),
      active: true,
    },
  ];

  const { receiptList } = useSelector((state) => state.receiptReducer);

  useEffect(() => {
    dispatch(fetchReceiptList());
  }, [dispatch]);

  const customCellRenderer = (params) => {
    if (!params.data || !params.data.receiptId || !params.data.status)
      return null;
    return (
      <ButtonColumn
        editLink={`/order-detail/` + params.data.receiptId}
        status={params.data.status}
        value={params}
      />
    );
  };

  //settings za tabelu
  const columnDefs = [
    {
      headerName: t("promotionList.countryName"),
      field: "countryName",
      filter: "agSetColumnFilter",
      width: 150,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("orderList.receiptNumber"),
      field: "receiptNumber",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("orderList.dateOnReceipt"),
      field: "dateOnReceipt",
      filter: "agDateColumnFilter",
      valueGetter: dateValueGetter,
      filterParams: dateFilterParams,
      valueFormatter: (params) => formatOnlyDate(params.value),
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("orderList.status"),
      field: "status",
      filter: "agTextColumnFilter",
      width: 150,
      cellRenderer: statusRenderOrder,
      valueGetter: (params) => {
        if (!params.data || !params.data.status) return null;
        switch (params.data.status) {
          case "PENDING":
            return t("orderList.statusPending");
          case "REJECTED":
            return t("orderList.statusRejected");
          case "APPROVED":
            return t("orderList.statusApproved");
          default:
            return "";
        }
      },
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("orderList.name"),
      field: "name",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 180,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("orderList.lastName"),
      field: "lastName",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("orderList.companyName"),
      field: "companyName",
      filter: "agSetColumnFilter",
      flex: 1,
      minWidth: 220,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: t("orderList.storeName"),
      field: "storeName",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 220,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
    {
      headerName: "",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 60,
      cellStyle: {
        display: "flex",
        alignItems: "center",
      },
    },
  ];

  return (
    <Fragment>
      <Breadcrumb
        type={translateModule}
        pageType={pageType}
        breadcrumbItems={breadcrumbItems}
      />
      <AggridTable
        rowData={receiptList}
        columnDefs={columnDefs}
        gridStateKey={"receipt-list"}
        buttonStatistic={true}
      />
    </Fragment>
  );
};

export default OrderList;
